import React from 'react';
import Link from 'gatsby-link';
import styles from './styles.module.css';

import ImageIcon from '../../icons/Image';
import Square from '../square';

// Valid sizes are SMALL / MEDIUM / LARGE

export default ({ size = 'MEDIUM' }) => (
  <Square>
    <div className={styles.container}>
      <div className={styles.icon}>
        <ImageIcon size="100%" color="#333" />
      </div>
      <p>No image</p>
    </div>
  </Square>
);



// WEBPACK FOOTER //
// ./src/components/image-placeholder/index.js